import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import UserLockers from '../components/UserLockers';
import UserDetailsComponent from '../components/UserDetailsComponent';
import { getBulkAdvanceBookingAssignLockers } from '../api/api';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, USER_INFO } from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';
import ButtonComponent from '../components/ButtonComponent';
import { useTranslation } from 'react-i18next';
import { getPathForNextPage } from '../lib/Utils';
import { HOME, MAP, USER_ACCOUNT } from '../assets/constants/PageList';

// Transform Function
const transformLockerData = (apiData) => {
  if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
    console.error("Invalid API structure:", apiData);
    return [];
  }

  return apiData.data
    .filter(
      locker =>
        locker.status === "reserved" &&
        locker.payment_status === "completed"
    )
    .map(locker => ({
      amount: locker.amount,
      assignment: locker.assignment,
      currency: locker.currency,
      locker_bank_name: locker.locker_bank_name,
      order_id: locker.order_id,
      payment_id: locker.payment_id,
      payment_status: locker.payment_status,
      ref_id: locker.ref_id,
      reserve_end: locker.reserve_end,
      reserve_start: locker.reserve_start,
      status: locker.status,
      transactions: locker.transactions || [],
      user: locker.user
    }));
};

export default function UserProfilePage() {
  const history = useHistory();
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState(t('loading_text'));
  const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
  const isAssignmentPricingEnabled = settings?.is_pricing;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setLoadingMessage(t('getting_user_data_text'));

      const user = await getSecureItemFromSpecificStorage(
        LOCAL_STORAGE,
        USER_INFO
      );
      if(user){
          setUserInfo(user);
      }
      else{
        const anonymousUser = {
        username: "anonymous",
        email: "anonymous@gmail.com",
        mobile_number: "+91XXXXXXXXXX",
        date_joined: '01-01-2001'
      };
      setUserInfo(anonymousUser);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingMessage(t('something_went_wrong_text'));
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className='user-profile-page'>
      {isLoading ? (
		<div className='main'>
			<CircularProgressLoader message={loadingMessage} />
		</div>
      ) : (
        <div className='main'>
          <div className='heading-container'>
            <h1 className='heading'>{t('my_account_title')}</h1>
            <p className='paragraph'>
              {/* {t('manage_bookings_and_subscription_text')} */}
              Manage your booking details and account information here.
            </p>
          </div>
        
          <div className='user-details-container'>
            <UserDetailsComponent userInfo={userInfo} />
          </div>
        {isAssignmentPricingEnabled &&
        <>
          <div className='user-profile-actions'>
            <div className='actions-title'>{t('quick_actions_title')}</div>
            <div className='actions-buttons'>
              <ButtonComponent
                handleClick={() => history.push(getPathForNextPage(USER_ACCOUNT, MAP))}
                title={'book_in_advance'}
              />
              <ButtonComponent
                handleClick={() => history.push(getPathForNextPage(USER_ACCOUNT, HOME))}
                title={'active_bookings'}
              />
            </div>
          </div>
          <div className='user-lockers-container'>
			        <UserLockers/>
          </div>
          </>
          }
        </div>
      )}

    </div>
  );
}
